import React, { useCallback, useEffect, useRef, useState } from "react";
import { Grid, List, NavBar, Swiper, Tabs } from 'antd-mobile'

import { 
    BodyView,
    ListView,
    TabsView
} from "../factory/ViewUtil";
import { isLogin, RequestTradeCoinDone, RequestTradeCoinUndo, RequestTradeCoinUndone } from "../../NetworkFactory";
import { CellStateView } from "../factory/CellViews";
import { ToastClear, ToastContent, ToastLoading, ToDate5, TradeLightValueColor } from "../factory/FactoryUtil";
import { CoinCellView } from "./TradeCellView";
import { RefreshAssets } from "../assets/AssetsManager";

const tabItems = [
    { key: '1', title: 'All Delegate' },
    { key: '2', title: 'Order history' }
]

const HistoryItemView = React.memo(({data = {}}) => {
    const headerCss = {color : '#999', wordBreak : 'break-word'}
    const [name = '', symbol = ''] = (data.symbol || '').split('/')
    return (
        <List.Item className='cellCardBorder'>
            <Grid columns={3} style={{fontSize : '14px', alignItems : 'center', '--gap-vertical' : '4px', '--gap-horizontal' : '2px',}}>
                <Grid.Item style={{fontWeight : 'bold', wordBreak : 'break-word', color : TradeLightValueColor(data.way, 1)}}>{data.way === 1 ? 'Purchase' : 'Sell out'}</Grid.Item>
                <Grid.Item style={{fontWeight : 'bold', wordBreak : 'break-word'}}>{ToDate5(data.creationDate)}</Grid.Item>
                <Grid.Item style={{fontWeight : 'bold', textAlign : "right", wordBreak : 'break-word'}}>Completed</Grid.Item>

                <Grid.Item style={headerCss}>Handling fee({symbol})</Grid.Item>
                <Grid.Item style={headerCss}>Entrusted price({name})</Grid.Item>
                <Grid.Item style={{...headerCss, textAlign : 'right'}}>Entrusted volume({name})</Grid.Item>

                <Grid.Item style={{wordBreak : 'break-word'}}>{data.fee}</Grid.Item>
                <Grid.Item style={{wordBreak : 'break-word'}}>{data.entrust_price}</Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}>{data.entrust_amount}</Grid.Item>

                <Grid.Item style={headerCss}>Turnover total({symbol})</Grid.Item>
                <Grid.Item style={headerCss}>Turnover price({name})</Grid.Item>
                <Grid.Item style={{...headerCss, textAlign : 'right'}}>Turnover volume({name})</Grid.Item>

                <Grid.Item style={{wordBreak : 'break-word'}}>{data.turnover_volume}</Grid.Item>
                <Grid.Item style={{wordBreak : 'break-word'}}>{data.turnover_price}</Grid.Item>
                <Grid.Item style={{wordBreak : 'break-word', textAlign : 'right'}}>{data.turnover_amount}</Grid.Item>
            </Grid>
        </List.Item>
    )
})

const CoinOrderViewController = ({goback}) => {
    
    const swiperRef = useRef(null)
    const [activeIndex, setActiveIndex] = useState(0)
    const [doneData, setDoneData] = useState([])
    const [stateDoneCode, setStateDoneCode] = useState(3);

    const [undoneData, setUndoneData] = useState([])
    const [stateUndoneCode, setStateUndoneCode] = useState(3);

    const updateTab = (index) => {
        setActiveIndex(index)
    }

    //=========================================================
    const requestDoneData = useCallback(() => {
        RequestTradeCoinDone().then(response => {
            const {data = []} = response.data || {}
            setDoneData(data)
            setStateDoneCode(data.length > 0 ? -1 : 1)
        }).catch(() => {
            setStateDoneCode(1)
        })
    }, [activeIndex]) // eslint-disable-line react-hooks/exhaustive-deps

    //=========================================================
    const requestUnDoneData = useCallback(() => {
        RequestTradeCoinUndone().then(response => {
            const {data = []} = response.data || {}
            setUndoneData(data)
            setStateUndoneCode(data.length > 0 ? -1 : 1)
        }).catch(() => {
            setStateUndoneCode(1)
        })
    }, [activeIndex]) // eslint-disable-line react-hooks/exhaustive-deps

    //=========================================================
    useEffect(() => {
        if(!isLogin()) {
            return
        }
        if(activeIndex === 1) {
            setStateDoneCode(3)
            setDoneData([])
            requestDoneData()
        } else {
            setStateUndoneCode(3)
            setUndoneData([])
            requestUnDoneData()
        }
    }, [activeIndex]) // eslint-disable-line react-hooks/exhaustive-deps

    //=========================================================
    // # 撤单
    const onUndo = ({id = ''}) => {
        if(id.length === 0) {
            ToastContent('Error')
            return
        }
        ToastLoading('Undoing...')
        RequestTradeCoinUndo({id : id + ''}).then(() => {
            ToastClear()
            setStateUndoneCode(3)
            setUndoneData([])
            requestUnDoneData()
            RefreshAssets('1')
        }).catch(() => {
            ToastContent('Error')
        })
    }
    return(
        <>
            <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>
                    <div style={{
                            display : 'flex',
                            height : '52px',
                            alignItems : 'center',
                            borderLeft : '18px transparent solid',
                            borderRight : '18px transparent solid',
                            boxSizing : 'border-box',
                            fontWeight : 'normal',
                            textAlign : 'center'
                        }}>
                            <div style={{margin : 'auto'}}>
                                <TabsView activeKey={tabItems[activeIndex].key}
                                    onChange={key => {
                                        const index = tabItems.findIndex(item => item.key === key)
                                        updateTab(index)
                                        swiperRef.current?.swipeTo(index)
                                }}>
                                    {tabItems.map(item => (
                                        <Tabs.Tab title={item.title} key={item.key} />
                                    ))}
                                </TabsView>
                            </div>
                    </div>
                </NavBar>
            </div>
            <BodyView content={{style : {'border' : 'none'}}} style={{paddingTop : '52px', paddingBottom : '10px'}}>
                <Swiper direction='horizontal' indicator={() => null}
                    allowTouchMove={false}
                    ref={swiperRef}
                    defaultIndex={activeIndex}
                    onIndexChange={index => {
                        updateTab(index)
                    }}
                    style={{ height : '100%'}}
                    >
                        <Swiper.Item>
                            <div style={{padding : '0 18px'}}>
                                <ListView>
                                    <CellStateView stateType={stateUndoneCode}/>
                                    {
                                        undoneData.map((item, index) => (
                                            <CoinCellView data={item} key={index} onUndo={()=>{onUndo(item)}}/>
                                        ))
                                    }
                                </ListView>
                            </div>
                        </Swiper.Item>
                        <Swiper.Item>
                            <div style={{padding : '0 18px'}}>
                                <ListView>
                                    <CellStateView stateType={stateDoneCode}/>
                                    {
                                        doneData.map((item, index) => (
                                            <HistoryItemView data={item} key={index}/>
                                        ))
                                    }
                                </ListView>
                            </div>
                        </Swiper.Item>
                </Swiper>
            </BodyView>
        </>
    );
}
export default React.memo(CoinOrderViewController)